export default __webpack_public_path__ + "static/media/gengarTexShiny.f9c399a0.jpg";